import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import AuthLayout from 'layouts/AuthLayout';
import AuthService from 'services/authService';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  async function handleSubmit(e) {
    const response = await AuthService.forgotPassword({ email });
    if (response.status === 'success') {
      toast.success(response.message);
      setTimeout(() => navigate('/login'), 2000);
    }
  }

  return (
    <AuthLayout>
      <div className="max-w-md w-full space-y-8">
        <div
          className="
          h-fit
          bg-[#202020]
          px-8 pt-12 pb-10
          rounded-xl
          text-white
          "
        >
          <h1 className="text-4xl font-light">Reset Password</h1>

          <div className="mt-8">
            <input
              className="
                w-full 
                bg-[#292929]
                outline-none
                rounded-lg px-3 p-4 mt-2
              "
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="flex flex-col gap-y-2 mt-5">
              <button type="submit" className="submit w-full rounded-lg p-4 bg-indigo-500 hover:bg-indigo-600 text-white" onClick={handleSubmit}>
                Send Email
              </button>
              <button
                type="submit"
                className="submit w-full rounded-lg p-4 bg-[#292929] hover:bg-[#313131] text-gray-400"
                onClick={() => {
                  navigate('/login');
                }}
              >
                Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
